// 下发记录
import http from "@/promise/http"
const CONTROLLER_NAME = "/issueOrder/"

// 下发记录列表
export const postListPage = (pageNum, numPerPage, params) => {
    return http.post(CONTROLLER_NAME.concat("listPage"), {
        pageNum: pageNum,
        numPerPage: numPerPage,
        condition: params
    });
};

// 重新下发
export function postReissue(ids) {
    return http.post(CONTROLLER_NAME.concat("reissue"), ids);
  }
  